import { defineFcm } from '../shared/factory';

export const FCM_ENFORCE_SECURE_IDENTIFIED_STATE = defineFcm('enforce_secure_identified_state')
	.asBoolean()
	.withDefault(false)
	.toConfig({
		owner: 'squad-site-platform',
		scope: ['corgi-middle-end', 'monorail'],
		context: 'Signatures',
		description:
			'This flag prevents guest users from signing unless authenticated if they match an existing user. It also prevents a user from getting a list of signed petition if they are not authenticated.',
		import: false,
	});
